import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseIntAsYear } from '../Parsers/TEDParseIntAsYear';
import { TEDDisplayIntAsYear } from '../Displayers/TEDDisplayIntAsYear';
import { IFormatter } from '../FormatterTypes';

class TEDFormatIntAsYear implements IFormatter {
  displayer = TEDDisplayIntAsYear.getInstance();
  parser = TEDParseIntAsYear.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatIntAsYear };
